import React from 'react';
import './Shimmer.scss';

const ShimmerStats = () => {
  return (
    <div className='header-stat'>
      <div className='shimmer-stat' />
      <div className='shimmer-stat' />
    </div>
  );
};

export default ShimmerStats;
